import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import { getMyActiveLicenses, getMyActiveLicensesById } from '../../../actions/license';
import { diffrenceInDays } from '../../../utils';
const LicenseModal = ({ open, handleClose, planId, id, type }) => {
	const [MyLicenses, setMyLicenses] = useState([]);

	useEffect(() => {
		let isMounted = true;

		const applyResult = (res) => {
			if (!isMounted) return;

			if (res && res.status) {
				const currentTimestamp = Date.now(); // Get the current timestamp

				const validLicenses = res.data.data.filter((license) =>
					license.expireDate !== null && license.expireDate > currentTimestamp
				);

				setMyLicenses(validLicenses);
			}
			else {
				setMyLicenses([]);
			}
		};

		const applyError = () => {
			if (isMounted) setMyLicenses([]);
		};

		if (id) {
			getMyActiveLicensesById(id).then(applyResult).catch(applyError);
		}
		else {
			getMyActiveLicenses(planId).then(applyResult).catch(applyError);
		}

		return () => {
			isMounted = false;
		};
	}, [planId, id]);

	const leftTime = (lic, allowedHours) => {
		// const allowedHours = userType === 'SalesAgent' ? 50 : 60;

		if (lic?.duration > 0) {
			const diff = allowedHours * 60 - lic.duration;

			let str = `${Math.floor(diff / 60)} Hours`;

			str += Math.floor(diff % 60) > 0 ? ` ${Math.floor(diff % 60)} Minutes` : '';

			return str;
		}
		else {
			return `${allowedHours} Hours`;
		}
	};

	const renderLicenseDetails = (license) => {
		switch (license.planId) {
			case 'customerPlanA':
				return (
					<span>
						Personal Conference Room : {license?.name}
						<br />
						Good for 25 hours with 25 Participants/Mtg
					</span>
				);
			case 'customerPlanB':
				return (
					<span>
						Basic Conference Room : {license?.name}
						<br />
						Good for 60 hours with 200 Participants/Mtg
					</span>
				);
			case 'customerPlanC':
				return (
					<span>
						Basic Pro Conference Room : {license?.name}
						<br />
						Good for 70 hours with 300 Participants/Mtg
					</span>
				);
			case 'customerPlanD':
				return (
					<span>
						KonX eCard : {license?.name}
						<br />
						Good for 80 hours/license with 500 Participants
					</span>
				);
			case 'EnterpriseRoom':
				return (
					<span>
						Enterprise Conference Room : {license?.name}
						<br />
						Good for 80 hours/license with 1000 Participants
					</span>
				);
			case 'BusinessRoom':
				return (
					<span>
						Business Conference Room : {license?.name}
						<br />
						Unlimited Number of Meetings / Month Up to 300 Participants/Meeting
					</span>
				);
			case 'CorporateRoom':
				return (
					<span>
						Corporate Conference Room : {license?.name}
						<br />
						Unlimited Number of Meetings / Month Up to 500 Participants/Meeting
					</span>
				);
			case 'eCard':
				return (
					<span>
						Free KonX eCard : {license?.name}
						<br />
						Up to 100 Participants / Meeting
					</span>
				);
			case 'planC':
				switch (license.type) {
					case 'ECR':
						return (
							<span>
								Enterprise Conference Room : {license?.name}
								<br />
								Good for 80 hours with 1000 Participants/Mtg
							</span>
						);
					case 'BPCR':
						return (
							<span>
								Basic Pro Conference Room : {license?.name}
								<br />
								Good for 70 hours with 300 Participants/Mtg
							</span>
						);
					case 'BACR':
						return (
							<span>
								Basic Conference Room : {license?.name}
								<br />
								Good for 60 hours with 200 Participants/Mtg
							</span>
						);
					case 'PCR':
						return (
							<span>
								Personal Conference Room : {license?.name}
								<br />
								Good for 25 hours with 25 Participants/Mtg
							</span>
						);
					case 'eCard':
						return (
							<span>
								KonX eCard : {license?.name}
								<br />
								Good for 80 hours/license with 500 Participants
							</span>
						);
					default:
						return <span>Unknown Plan</span>;
				}
			case 'planA':
				switch (license.type) {
					case 'ECR':
						return (
							<span>
								Enterprise Conference Room : {license?.name}
								<br />
								Good for 80 hours with 1000 Participants/Mtg
							</span>
						);
					case 'BPCR':
						return (
							<span>
								Basic Pro Conference Room : {license?.name}
								<br />
								Good for 70 hours with 300 Participants/Mtg
							</span>
						);
					case 'BACR':
						return (
							<span>
								Basic Conference Room : {license?.name}
								<br />
								Good for 60 hours with 200 Participants/Mtg
							</span>
						);
					case 'PCR':
						return (
							<span>
								Personal Conference Room : {license?.name}
								<br />
								Good for 25 hours with 25 Participants/Mtg
							</span>
						);
					case 'eCard':
						return (
							<span>
								KonX eCard : {license?.name}
								<br />
								Good for 80 hours/license with 500 Participants
							</span>
						);
					default:
						return <span>Unknown Plan</span>;
				}
			case 'planB':
				switch (license.type) {
					case 'eCard':
						return (
							<span>
								KonX eCard : {license?.name}
								<br />
								Good for 80 hours/license with 500 Participants
							</span>
						);
					default:
						return <span>Unknown Plan</span>;
				}
			default:
				switch (license.type) {
					case 'ECR':
						return (
							<span>
								Enterprise Conference Room : {license?.name}
								<br />
								Good for 80 hours with 1000 Participants/Mtg
							</span>
						);
					case 'BPCR':
						return (
							<span>
								Basic Pro Conference Room : {license?.name}
								<br />
								Good for 70 hours with 300 Participants/Mtg
							</span>
						);
					case 'BACR':
						return (
							<span>
								Basic Conference Room : {license?.name}
								<br />
								Good for 60 hours with 200 Participants/Mtg
							</span>
						);
					case 'PCR':
						return (
							<span>
								Personal Conference Room : {license?.name}
								<br />
								Good for 25 hours with 25 Participants/Mtg
							</span>
						);
					case 'eCard':
						return (
							<span>
								KonX eCard : {license?.name}
								<br />
								Good for 80 hours/license with 500 Participants
							</span>
						);
					case 'BCR':
						return (
							<span>
								Business Conference Room : {license?.name}
								<br />
								Unlimited Number of Meetings / Month Up to 300 Participants/Meeting
							</span>
						);
					case 'CCR':
						return (
							<span>
								Corporate Conference Room : {license?.name}
								<br />
								Unlimited Number of Meetings / Month Up to 500 Participants/Meeting
							</span>
						);
					default:
						return <span>Unknown Plan</span>;
				}
		}
	};

	const nameMapping = {
		PCR: 'Personal Conference Room',
		BACR: 'Basic Conference Room',
		BPCR: 'Basic Pro Conference Room',
		ECR: 'Enterprise Conference Room',
		BCR: 'Business Conference Room',
		CCR: 'Corporate Conference Room',
		'eCard_planC': 'KonX eCard',
		'eCard_planB': 'KonX eCard',
		'eCard_planA': 'KonX eCard',
		customerPlanA: 'Personal Conference Room',
		customerPlanB: 'Basic Conference Room',
		customerPlanC: 'Basic Pro Conference Room',
		customerPlanD: 'KonX eCard',
		EnterpriseRoom: 'Enterprise Conference Room',
		BusinessRoom: 'Business Conference Room',
		CorporateRoom: 'Corporate Conference Room'
	};

	const filteredLicenses = MyLicenses?.filter((license) => {
		const eCardOne = license.planId.length == 24 && license.type == 'eCard' ? 'customerPlanD' : '';
		const eCardTwo = license.planId == 'planA' && license.type == 'eCard' ? 'customerPlanD' : '';
		const eCardThree = license.planId == 'planA' && license.type == 'eCard' ? 'customerPlanD' : '';
		const eCardFour = license.planId == 'planB' && license.type == 'eCard' ? 'customerPlanD' : '';
		const eCardFive = license.planId == 'planC' && license.type == 'eCard' ? 'customerPlanD' : '';

		// Determine the name from the nameMapping
		const name = nameMapping[eCardOne] || nameMapping[eCardTwo] || nameMapping[eCardThree] ||
			nameMapping[eCardFour] || nameMapping[eCardFive] ||
			nameMapping[license.type] || nameMapping[license.planId] || 'Unknown License';

		// If planId is provided and matches the name, return true to include the license
		return !planId || planId === name;
	});

	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
			<Box
				sx={{
					position: 'absolute',

					top: '50%',

					left: '50%',

					transform: 'translate(-50%, -50%)',

					width: 600,

					bgcolor: 'background.paper',

					boxShadow: 24,

					p: 4,

					borderRadius: 2,

					overflowY: 'auto',

					maxHeight: '100vh'
				}}
			>
				<Typography id='modal-title' variant='h6' component='h2' sx={{ mb: 2 }}>
					Active Products Details
				</Typography>
				<div className='row'>
					{filteredLicenses?.filter((item) => {
						if (type === '' || type == undefined) {
							return true;
						}

						return item.type === type && item.planId === planId;
					}).map((item, index) => {
						return (
							<div key={index} className='card w-100'>
								<div style={{ marginTop: '10px' }}>
									<Button
										style={{
											marginRight: '10px'
										}}
										className='cursor-pointer'
										variant="contained"
										size="small"
										onClick={() => {
											navigator.clipboard.writeText(`${window.location.origin}/guest-join/${item._id}`);
											const button = event.target;
											const originalText = button.textContent;
											button.textContent = 'Copied!';
											setTimeout(() => {
												button.textContent = originalText;
											}, 2000);
										}}
									>
										Copy Link
									</Button>
									<input
										type="text"
										value={`${window.location.origin}/guest-join/${item._id}`}
										readOnly
										style={{
											padding: '5px',
											width: '250px',
											marginRight: '10px'
										}}
									/>
								</div>
								<br />
								{renderLicenseDetails(item)}
								{item?.expireDate ? (
									<span className='textCntr'>

										{(item.planId == 'planC' && item.type == 'eCard') || (item.planId == 'planB' && item.type == 'eCard') || item.planId == 'eCard' || (item.planId.length == 24 && item.type == 'eCard') ? '' :
											item.planId !== 'customerPlanD' ?
												<>
													<br />
													<span>License is going to expire in {diffrenceInDays(new Date().valueOf(), item?.expireDate)} days </span>
												</> : ''

										}
										<br />
										{(item.planId !== 'BusinessRoom' && item.planId !== 'CorporateRoom' && item.type !== 'BCR' && item.type !== 'CCR') ? (
											<>
												{leftTime(item,
													item.planId == 'eCard' ? 10 : item.planId == 'planC' && item.type == 'eCard' ? 80 : item.planId === 'customerPlanD' ? 80 :
														item.planId === 'customerPlanC' ? 70 :
															item.planId === 'EnterpriseRoom' ? 80 :
																item.type === 'BPCR' ? 70 : item.planId == 'planB' ? 80 : item.type == 'ECR' ? 80 : item.type == 'PCR' ? 25 : item.type == 'eCard' && item.planId.length == 24 ? 80 : 60
												)}
												{' '}left out of{' '}
												{item.planId == 'eCard' ? '10 ' : item.planId == 'planC' && item.type == 'eCard' ? '80 ' : item.planId === 'customerPlanD' ? '80' :
													item.planId === 'customerPlanC' ? '70 ' :
														item.planId === 'EnterpriseRoom' ? '80 ' :
															item.type === 'BPCR' ? '70 ' : item.planId == 'planB' ? '80 ' : item.type == 'ECR' ? '80 ' : item.type == 'PCR' ? '25 ' : item.type == 'eCard' && item.planId.length == 24 ? '80 ' : '60 '}
												Hours
											</>
										) : null}
									</span>
								) : null}
							</div>
						);
					})}
				</div>

				<Button onClick={handleClose} variant='contained' color='primary' style={{ marginTop: 10 }} sx={{ mt: 3 }}>
					Close
				</Button>
			</Box>
		</Modal>
	);
};

export default LicenseModal;